<script setup>
import { Link } from '@inertiajs/vue3';
import AppLayout from '@/Layouts/AppLayout.vue';
import HotelSubMenu from '@/Includes/HotelSubMenu.vue';
import RoomEditModal from "@/Pages/Rooms/editModal.vue";
import RoomAddModal from "@/Pages/Rooms/addModal.vue";
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css'
import { useToast } from 'vue-toast-notification';

const props = defineProps({
    year: String,
    rooms: Object,
    hotelsById: Object,
    card: Boolean,
    addcard: Boolean,
    roomDetails: Object,
    roomamenities: Array,
    allRoomCategory: Array,
    flash: Object,
    user: Object,
});

const $toast = useToast();
let menu = 'rooms';

function deleteRoom(value) {
    new Swal({
        title: 'Are you sure?',
        text: "All the data related to this object will be deleted!",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#d33',
        confirmButtonText: 'I am sure!'
    }).then((result) => {
        if (result.isConfirmed) {
            setTimeout(() => {
                window.location.href = '/rooms/deleteRoom/' + value;
            }, 300);

            $toast.success('Room deleted successfully!', {
                position: 'top-right',
                duration: 4000,
                hideProgressBar: true,
                icon: true,
                type: "info",
                class: 'bs-toast toast bg-dark show'
            });
        }

    })
}

</script>
<template>
    <AppLayout title="Hotel Rooms" :year=year :user=user>
        <div class="container-xxl flex-grow-1 container-p-y">
            <HotelSubMenu :hotelsById="hotelsById" :menu="menu" />
            <div class="row g-4">
                <div class="col-xl-4 col-lg-6 col-md-6" v-for="(room, index) in rooms" :key="room.id">
                    <div class="card">
                        <div class="card-body">
                            <div class="d-flex align-items-center mb-3">
                                <a href="javascript:;" class="d-flex align-items-center">
                                    <div class="avatar avatar-sm me-2">
                                        <img :src="'/fetchRoomImage/d?id=' + room.id + '&w=80&h=80&fit=crop'"
                                            :alt="room.room_category ? room.room_category.name : 'Category name not set'"
                                            class="rounded-circle" />
                                    </div>
                                    <div v-if="room.room_category" class="me-2 text-body h5 mb-0"
                                        v-text="room.room_category.name">
                                    </div>
                                    <div v-else class="badge bg-label-danger">Category name not set</div>
                                </a>
                                <div class="ms-auto">
                                    <ul class="list-inline mb-0 d-flex align-items-center">
                                        <li class="list-inline-item">
                                            <div class="dropdown">
                                                <button type="button" class="btn dropdown-toggle hide-arrow p-0"
                                                    data-bs-toggle="dropdown" aria-expanded="false">
                                                    <i class="bx bx-dots-vertical-rounded"></i>
                                                </button>
                                                <ul class="dropdown-menu dropdown-menu-end">
                                                    <li v-if="$page.props.user.permissions.includes('edit-rooms')">
                                                        <Link class="dropdown-item"
                                                            :href="'/rooms/getRoomsByRoomId/' + room.id + '/' + hotelsById.id"
                                                            preserve-scroll replace>
                                                        Edit Room</Link>
                                                    </li>
                                                    <li v-if="$page.props.user.permissions.includes('edit-rooms')">
                                                        <hr class="dropdown-divider" />
                                                    </li>
                                                    <li v-if="$page.props.user.permissions.includes('remove-rooms')">
                                                        <Link class="dropdown-item text-danger" href="#"
                                                            @click="deleteRoom(room.id)" preserve-scroll replace>
                                                        Remove Room</Link>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <span v-html="room.description.slice(0, 180)"></span>
                            <div class="d-flex align-items-center flex-wrap">
                                <div class="ms-auto">
                                    <span class="badge bg-label-primary me-2" v-if="room.extra_bed_allowed == 1">Extra
                                        Bed Available</span>
                                    <span class="badge bg-label-primary me-2"
                                        v-if="room.baby_cot_availability == 1">Baby
                                        Cot Available</span>
                                    <span class="badge bg-label-primary me-2" v-if="room.number_of_rooms">{{
                                        room.number_of_rooms
                                    }} Units</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <RoomEditModal v-if="props.card" :card="props.card" :roomDetails="props.roomDetails"
            :roomamenities="props.roomamenities" :rooms="props.rooms" :allRoomCategory="allRoomCategory"
            :flash="flash" />

        <RoomAddModal v-if="props.addcard" :addcard="props.addcard" :roomamenities="props.roomamenities"
            :allRoomCategory="props.allRoomCategory" :hotelsById="props.hotelsById" :flash="flash" />
    </AppLayout>
</template>